import { Container, Paper, ThemeProvider } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import {
  Grid,
  IconButton,
  InputBase,
  Typography,
  createTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import Fuse from "fuse.js";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { v4 as uuid } from "uuid";
import DevisionCardSuppliersCmp from "../../components/cards/devisionCardSuppliersCmp";
import { SUPPLIERIDS } from "../../config/cacheKey";
import { GetSuppliersResponse, suppliers } from "../../models/report.model";
import { GetSuppliersList } from "../../services/report.service";
import SuppliersCardSkeleton from "../../components/skeletons/suppliersCardSkeleton";
import { useSelector } from "react-redux";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: "1rem" },
      },
    },
  },
});
const style = {
  maxHeight: "78vh",
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "1.7vh",
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const SuppliersList = () => {
  const jsonFile = useSelector((state: any) => state.style);

  const [data, setData] = useState<suppliers[]>([]);
  const [allowAddSupplier, setAllowAddSupplier] = useState<boolean>();
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();

  const { isLoading } = useQuery<GetSuppliersResponse>(
    SUPPLIERIDS,
    GetSuppliersList,
    {
      onSuccess(data) {
        if (data) {
          setData(data.suppliers);
          setAllowAddSupplier(data.allowAddSupplier);
        }
      },
    }
  );

  const fuse = new Fuse(data, {
    keys: ["title"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const titleResults = searchTerm ? results.map((title) => title.item) : data;

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <div>
          <Box sx={{ marginBottom: "2rem" }} paddingRight={"2.3vh"}>
            <Grid
              container
              spacing={2}
              alignItems={"start"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              {allowAddSupplier && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <Typography
                    textAlign={{
                      xs: "center",
                      sm: "center",
                      md: "left",
                      lg: "left",
                      xl: "left",
                    }}
                    component={"p"}
                    sx={{ cursor: "pointer" }}
                    color={jsonFile?.mainColor}
                    fontWeight={"bold"}
                    fontSize={"1rem"}
                    onClick={() => {
                      history.push({
                        pathname: "/SuppliersList/AddSupplier",
                      });
                    }}
                  >
                    <AddCircleOutlineIcon
                      fontSize="small"
                      sx={{ marginLeft: "5px" }}
                    />
                    ثبت پذیرنده جدید
                  </Typography>
                </Grid>
              )}

              <Grid item width={"100%"} xs={12} sm={6} md={4} lg={3} xl={3}>
                <Paper
                  elevation={0}
                  style={{
                    border: "1px solid #DAE0E4",
                    display: "flex",
                  }}
                  square={false}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1, paddingX: "16px" }}
                    placeholder="جستجو"
                    onChange={handleSearchInput}
                  />

                  <IconButton
                    type="button"
                    sx={{ color: "#9AAFC4" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </Grid>
            </Grid>
          </Box>

          <Box sx={style}>
            <Grid container spacing={2} sx={{ direction: "rtl" }}>
              {!isLoading
                ? titleResults.map((item) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      xl={3}
                      key={uuid()}
                      onClick={() => {
                        history.push({
                          pathname: "/SuppliersList1/SuppliersListDetail",
                          state: { id: item.id },
                        });
                        localStorage.setItem(
                          "SUPPLIER_ID",
                          JSON.stringify(item.id)
                        );
                      }}
                    >
                      <DevisionCardSuppliersCmp {...item} />
                    </Grid>
                  ))
                : [...Array(20)].map(() => <SuppliersCardSkeleton />)}
            </Grid>
          </Box>
        </div>
      </ThemeProvider>
    </>
  );
};

export default SuppliersList;
